export default {
  props: {
    name: String,
    data: Object,
  },
  methods: {
    onClick() {
      this.$emit('click', this.data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/refine-link/refine-link.js